import { $Qll, $Q } from '../utils/query-selector';

/**
 * Toggle description
 * @param {Event} e Click event target
 */
function toggleDescription(e) {
  // ? Get container
  let parent = e.target;
  if (
    parent.tagName.toLowerCase() !== 'button' &&
    parent.tagName.toLowerCase() !== 'span'
  ) {
    parent = e.target.closest('span');
  }
  const identifier = parent.getAttribute('data-identifier');

  // ? Get description and button to toggle description
  const description = $Q(`.toggle-description#${identifier} .description`);
  const button = $Q(`.toggle-description#${identifier} .toggle-text`);

  // ? Toggle shown class
  description.classList.toggle('shown');

  if (description.classList.contains('shown')) {
    // ? If it is shown, change text and icon of button toggle
    $Q('.text', button).innerHTML = button.getAttribute('data-hide');
    $Q('.show', button).classList.add('hidden');
    $Q('.hide', button).classList.remove('hidden');
  } else {
    // ? If it isn't shown, change text and icon of button toggle
    $Q('.text', button).innerHTML = button.getAttribute('data-show');
    $Q('.show', button).classList.remove('hidden');
    $Q('.hide', button).classList.add('hidden');
  }
}

// eslint-disable-next-line complexity
export function validateSizeDescription(element) {
  const sizeWindow = window.innerWidth
  const inputSizeText = $Q('input', element)
  const sizeText = inputSizeText.value;
  const allSizeText = inputSizeText.getAttribute('data-text')
    .split('')
    .map((text) => (text === '\n' ? 56 : 1))
    .reduce((a, b) => a + b, 0)

  let requireToggle = true;
  if (sizeWindow <= 425 && Number(allSizeText) <= 300) {
    // ? Mobile
    requireToggle = false
  } else if (
    sizeWindow > 425 &&
    sizeWindow <= 768 &&
    Number(allSizeText) <= 551
  ) {
    // ? Tablet
    requireToggle = false
  } else if (sizeWindow > 768 && Number(sizeText) <= 300) {
    // ? Desktop
    requireToggle = false
  }

  if (!requireToggle) {
    element.parentNode.classList.add('normal-size')
    element.classList.add('hidden')
  }
}

/**
 * Initialize toggle description
 */
export function initializeToggleDescription() {
  document.addEventListener('DOMContentLoaded', () => {
    const descriptions = $Qll('.toggle-description .toggle-text')
    if (descriptions && descriptions.length > 0) {
      // eslint-disable-next-line complexity
      descriptions.forEach((element) => {
        element.addEventListener('click', toggleDescription);

        validateSizeDescription(element)
      });
    }
  });
}

/**
 * Add toggle event for a specific element, for example, in a section rendering
 * @param {String} parent Class or ID of parent
 */
export function handleToggleDescriptionPopup(parent) {
  $Q(`${parent} .toggle-description .toggle-text`).addEventListener(
    'click',
    toggleDescription,
  );
}
